import { render, staticRenderFns } from "./PaasRoutes.vue?vue&type=template&id=6a091198&"
import script from "./PaasRoutes.vue?vue&type=script&lang=js&"
export * from "./PaasRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports